var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 3.5576C0 1.5968 1.62418 0 3.6196 0H7.58845C9.5798 0 11.1999 1.592 11.1999 3.5496V12.4424C11.1999 14.404 9.57573 16 7.57949 16H3.61227C1.62011 16 0 14.408 0 12.4504V11.6984V3.5576Z",
    fill: "#83889D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8232 7.56389L13.5466 5.23669C13.3113 4.99669 12.9326 4.99669 12.6981 5.23829C12.4644 5.47989 12.4651 5.86949 12.6997 6.10949L13.947 7.38389H12.7511H6.03889C5.70776 7.38389 5.43896 7.65989 5.43896 7.99989C5.43896 8.34069 5.70776 8.61589 6.03889 8.61589H13.947L12.6997 9.89029C12.4651 10.1303 12.4644 10.5199 12.6981 10.7615C12.8157 10.8823 12.9692 10.9431 13.1235 10.9431C13.2762 10.9431 13.4297 10.8823 13.5466 10.7631L15.8232 8.43669C15.9362 8.32069 16 8.16389 16 7.99989C16 7.83669 15.9362 7.67989 15.8232 7.56389Z",
    fill: "#83889D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.3034e0439a024fcc2269789cfb906153.svg";
export { ForwardRef as ReactComponent };